query GetInvestmentDailyBalances(
  $investmentPeriodId: ID!
  $legalEntityName: String!
  $currencyFilter: String
) {
  investmentDailyBalances(
    investmentPeriodId: $investmentPeriodId
    legalEntityName: $legalEntityName
    currencyFilter: $currencyFilter
  ) {
    fundId
    fundAccountId
    fundSalesforceId
    fundName
    legalEntityName
    month
    date
    balance {
      minorUnit
      currency
    }
  }
}
